// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"r7-z"};